import React from "react";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import styled, { css } from "styled-components";
import actions from "../../../../../../redux/client/actions";
import { UnStyledButton } from "../../../../../../components/button/button.styles";
import { PRIVATE_ROUTE } from "../../../../../../route.constants";
import { isNotNullOrEmpty } from "../../../../../../utils/helpers/stringHelper";

const Wrapper = styled.div(({ theme }) => css`
  display: flex;
  flex-direction: column;

  .debit-card-subtitle {
    padding: 10px 0 30px;
  }

  .debit-card-submit {
    display: flex;
    justify-content: flex-end;
  }

  .debit-card-button {
    margin: 30px 0 0;
    background-color: ${theme.buttons.secondary.background};
    color: ${theme.buttons.secondary.color};
    font-size: ${theme.buttons.fontSize};
    font-weight: ${theme.buttons.fontWeight};

    @media (hover: hover) {
      &:hover {
        color: ${theme.buttons.secondary.colorHover};
        background-color: ${theme.buttons.secondary.backgroundHover};
      }
    }
  }
`);

export const PayDebitCard = ({ accountId, isFullArrears }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const navToPaymentForm = () => {
    dispatch(actions.setAccountId(accountId));
    if (isFullArrears && isNotNullOrEmpty(isFullArrears)) {
      dispatch(actions.setFullArrears());
    }
    history.push({
      pathname: PRIVATE_ROUTE.EZIDEBIT,
    });
  };

  return (
    <Wrapper>
      <h3>How to pay?</h3>
      <p className="debit-card-subtitle">
        Once you have confirmed your method of payment, you will be redirected to our direct debit form.
      </p>
      <div className="debit-card-submit">
        <UnStyledButton
          onClick={() => navToPaymentForm()}
          className="debit-card-button"
        >
          I Agree And Confirm My Request
        </UnStyledButton>
      </div>
    </Wrapper>
  );
};
